// extracted by mini-css-extract-plugin
module.exports = {"decline":"ButtonDigital_decline__1j3xf","confirm":"ButtonDigital_confirm__3hY99"};